  <div class="modal fade" bsModal tabindex="-1" role="dialog" aria-labelledby="LatestUpdate" aria-hidden="true" #confirmationcountrycontentdialogmodal="bs-modal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header bg-primary text-white">
                <p class="modal-title h3">
                    <strong>Confirmation required</strong>
                </p>
                <button type="button" class="btn btn-sm btn-primary" aria-label="Close" (click)="closeModal()">
                  <span aria-hidden="true"><i class="fa fa-close"></i></span>
                </button>
            </div>
            <div class="modal-body modal-border">
                <div class="row">
                    <div class="col">
                        <p class="text-muted mb-0" [innerHTML]="ccConfirmationText"></p>
                    </div>
                </div>
            </div>
            <div class="modal-footer bg-faded text-right">
                <button class="btn btn-outline-info btn-sm" (click)="onContentDeleteClick(false)">Cancel</button>
                <button class="btn btn-primary btn-sm ml-2" (click)="onContentDeleteClick(true)">Confirm</button>
            </div>
        </div>
    </div>
</div>